import { CustomMetaTitle } from 'Components';
import { MedicationHistoryList } from './MedicationHistoryList';
import { Title } from './Title';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { Stack } from '@mui/material';
import { useIsDesktop } from 'Hooks';

export const MedicationHistory = () => {
  const isDesktop = useIsDesktop();

  return (
    <Stack maxWidth={isDesktop ? '1013px' : 'initial'}>
      <CustomMetaTitle
        title={
          Dictionary[DICTIONARY.MedicationsAndPrescriptionsLobby].personalZone +
          ' - ' +
          Dictionary[DICTIONARY.MedicationsHistory].title +
          ' - ' +
          Dictionary[DICTIONARY.MedicationsHistory]
            .ministryOfDefenseRehabilitationCenter
        }
      />
      <Title />
      <MedicationHistoryList />
    </Stack>
  );
};
